import { Alert, Link, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import moment from "moment";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Avatar } from "../../components/Avatar";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
export class EventStats extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: [],

            loadingActiveEventData: true,
            activeEvent: null,
            activeEventData: [],
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/game_events/${this.props.match.params.gameEventKey}/stats`, {
                headers: { Authorization: Helpers.getSessionId() },
                timeout: 30000
            });

            this.setState({
                data: response.data,
                loading: false,
            })
        } catch (e) {
            PopupMessage.error(e.response.data.error);
        }
    }

    async fetchActiveEventData() {
        try {
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/game_events/active_event/${this.state.activeEvent}`, {
                headers: { Authorization: Helpers.getSessionId() },
                timeout: 30000
            });

            this.setState({
                activeEventData: response.data,
                loadingActiveEventData: false,
            })
        } catch (e) {
            PopupMessage.error(e.response.data.error);
        }
    }

    selectEvent(key: string) {
		this.setState({
			activeEventData: [],
			loadingActiveEventData: true,
			activeEvent: key,
		}, () => {
			this.fetchActiveEventData();
		})
	}

    clearActiveEvent() {
		this.setState({
			activeEvent: null,
			loadingActiveEventData: true,
			activeEventData: [],
		})
	}

    haveGroups() {
        if (this.state.loading) {
            return false;
        }

        return this.state.data[0]?.haveGroups || false;
    }

    renderTableBody() {
		if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={2}>
                    {Helpers.renderSkeletonRows(2, 50)}
                </TableCell>
            </TableRow>
        }

		if ((this.state?.data || []).length === 0) {
			return <TableCell colSpan={7}>
				<Alert severity="info">No Stats Found</Alert>
			</TableCell>
		}

		return (this.state?.data || []).map(item => (
			<TableRow key={item.key} hover={true} style={{ cursor: "pointer" }} onClick={(e) => this.selectEvent(item.key)}>
				<TableCell>{item.haveGroups ? "Yes" : "No"}</TableCell>
                <TableCell>{item.count}</TableCell>
                {this.haveGroups() && <React.Fragment>
                    <TableCell>{item.hqMin}</TableCell>
                    <TableCell>{item.hqMax}</TableCell>
                    <TableCell>{moment(item.created).format("D MMM YYYY, HH:mm")}</TableCell>
                </React.Fragment>}
			</TableRow>
		))
	}

    renderStatsList() {
		return <Table>
			<TableHead>
				<TableRow>
					<TableCell style={{ width: 150 }}>Grouped</TableCell>
					<TableCell style={{ width: 150 }}>Users</TableCell>
					{this.haveGroups() && <React.Fragment>
						<TableCell>Min Core Level</TableCell>
						<TableCell>Max Core Level</TableCell>
						<TableCell>Group Created At</TableCell>
					</React.Fragment>}
				</TableRow>
			</TableHead>
			<TableBody>
				{this.renderTableBody()}
			</TableBody>
		</Table>
	}

    renderActiveEventTable() {
		if (this.state.loadingActiveEventData) {
            return <TableRow key="loading-row">
                <TableCell colSpan={3}>
                    {Helpers.renderSkeletonRows(2, 50)}
                </TableCell>
            </TableRow>
        }

		if ((this.state?.activeEventData || []).length === 0) {
			return <TableCell colSpan={7}>
				<Alert severity="info">No Stats Found</Alert>
			</TableCell>
		}

		return (this.state?.activeEventData || []).map(item => (
			<TableRow key={item.id}>
				<TableCell>{Avatar(item)}</TableCell>
                <TableCell>
                    <NavLink to={`/players/${item.id}`}>
                        {item.name}
                    </NavLink>
                </TableCell>
                <TableCell>{item.value}</TableCell>
			</TableRow>
		))
	}

    renderEventItem() {
		return <Table style={{ marginTop: 10 }}>
			<TableHead>
				<TableRow>
					<TableCell style={{ width: 100 }}></TableCell>
					<TableCell>Username</TableCell>
					<TableCell style={{ width: 150 }}>Points</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{this.renderActiveEventTable()}
			</TableBody>
		</Table>
	}

    render() {
		return <React.Fragment>
			{this.state.activeEvent && <Link onClick={(e) => this.clearActiveEvent()}>Back</Link>}

			<Paper elevation={0}>
				{this.state.activeEvent ? this.renderEventItem() : this.renderStatsList()}
			</Paper>
		</React.Fragment>
	}
}
